import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";

var styles = {
  cardBlock: {
    minHeight: '8rem',
    minWidth: '16rem',
    maxWidth: '22rem',
    backgroundColor: colors.neutral.white,
    border: "0.2rem solid ".concat(colors.neutral[200]),
    borderRadius: '0.8rem',
    padding: '0.8rem',
    boxSizing: 'border-box'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem'
  },
  portfolioName: {
    fontSize: '1.4rem',
    margin: '0',
    lineHeight: '2rem'
  },
  portfolioLogo: {
    display: 'block',
    marginRight: '1rem',
    maxWidth: '17rem',
    height: 'auto',
    maxHeight: '2.5rem'
  },
  removeButton: {
    '& svg': {
      width: '2rem',
      height: '2rem'
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map